import { Fragment } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { AppConstant } from "../Utils/AppConstant";
import i18n from "../Utils/i18n";
import clsx from "clsx";

export const Language: React.FC = () => {
  const { t } = useTranslation();
  const languageKeys = AppConstant.LanguageKeys;
  const language = AppConstant.Languages;

  return (
    <Menu as="div" className="relative">
      <MenuButton className="relative flex rounded-full text-base font-medium text-white hover:text-yellow-500">
        <div className="px-2">{t("language")}</div>
      </MenuButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute right-0 mt-2 w-40 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none z-10">
          {languageKeys.map((lng) => (
            <MenuItem key={lng}>
              {({ active }) => (
                <button
                  onClick={() => i18n.changeLanguage(lng)}
                  className={clsx(
                    "block w-full px-4 py-2 text-left text-sm text-gray-700",
                    {
                      "bg-yellow-500": active,
                      "font-bold": i18n.resolvedLanguage === lng,
                    }
                  )}
                >
                  {language[lng].nativeName}
                </button>
              )}
            </MenuItem>
          ))}
        </MenuItems>
      </Transition>
    </Menu>
  );
};
